// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ThankYou/style.css
// module id = 2086
// module chunks = 0